// Multivariate Dependencies
import React from 'react';
// Components
import { Tab } from '../../../atoms/Tab';
import { Container } from '../../../common/styles/container';
export var TabGroupStructure = function (_a) {
    var tabsConfig = _a.tabsConfig, activeTab = _a.activeTab, onSelectTab = _a.onSelectTab, className = _a.className;
    return (React.createElement(Container, { role: 'tablist', className: className }, tabsConfig.map(function (_a) {
        var label = _a.label, badgeText = _a.badgeText, icon = _a.icon, iconOnly = _a.iconOnly, id = _a.id;
        return (React.createElement(Tab, { key: id, iconOnly: iconOnly, icon: icon, badgeText: badgeText, selected: activeTab === id, onClick: function () { return onSelectTab(id); } }, label));
    })));
};
//# sourceMappingURL=TabGroupStructure.js.map